module.exports = __webpack_public_path__ + "img/share_whale.f2a4054.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/honor_system/share_whale.png
// module id = nWb4
// module chunks = 15